// src/redux/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { sendOtp, verifyOtp } from "../../utilities/services/auth";
import { registerUser } from "../../utilities/services/userRegister";

// Async Thunks for API calls
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (phoneNumber, thunkAPI) => {
    try {
      const response = await sendOtp({ phone_number: phoneNumber });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Something went wrong"
      );
    }
  }
);

export const verifyUserOtp = createAsyncThunk(
  "auth/verifyUserOtp",
  async (otpData, thunkAPI) => {
    try {
      const response = await verifyOtp(otpData);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "OTP Verification failed"
      );
    }
  }
);

export const registerNewUser = createAsyncThunk(
  "auth/registerNewUser",
  async (userData, thunkAPI) => {
    try {
      const response = await registerUser(userData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "User Registration failed"
      );
    }
  }
);

// Slice definition
const authSlice = createSlice({
  name: "auth",
  initialState: {
    phoneNumber: "",
    otp: "",
    user: null,
    token: null,
    loading: false,
    loading2: false,
    error: null,
  },
  reducers: {
    setPhoneNumber: (state, action) => {
      state.phoneNumber = action.payload;
    },
    setOtp: (state, action) => {
      state.otp = action.payload;
    },
    clearAuthError: (state) => {
      state.error = null;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Login User
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.phoneNumber = action.payload.phone_number;
        state.token = action.payload.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Verify OTP
      .addCase(verifyUserOtp.pending, (state) => {
        state.loading2 = true;
        state.error = null;
      })
      .addCase(verifyUserOtp.fulfilled, (state, action) => {
        state.loading2 = false;
        state.token = action.payload.token;
      })
      .addCase(verifyUserOtp.rejected, (state, action) => {
        state.loading2 = false;
        state.error = action.payload;
      })

      // Register New User
      .addCase(registerNewUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerNewUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
      })
      .addCase(registerNewUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Actions
export const { setPhoneNumber, setOtp, clearAuthError, logout } =
  authSlice.actions;

// Reducer
export default authSlice.reducer;
